module.exports = __webpack_public_path__ + "media/application/images/projects/secondary_nav/extreme-big-0103849b284bb44a4c101b71e59bc0ad.jpg";